<popup-c class="bs-enabled"
		 head="Asset Information" size="large"
		 (closeCb)="closeCb.emit();">
	<div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;">
		<table class="w-75 mx-3 mb-2 simpleDataTable" style="table-layout: fixed; font-size: 14px;">
			<tr *ngIf="assetObj.is_quarantine">
				<td style="width: 15px;"><i class="far fa-bug text-muted"></i></td>
				<td style="width: 120px;"><b>Status: </b></td>
				<td>
					<span style="color: red;">Quarantined</span>
				</td>
			</tr>
			<tr>
				<td style="width: 15px;"><i class="far fa-user text-muted"></i></td>
				<td style="width: 120px;"><b>Owner: </b></td>
				<td>
					<span>{{assetObj.user}}</span>
				</td>
			</tr>
			<tr *ngIf="assetObj.category === 'Rule'">
				<td><i class="fas fa-shield-alt text-muted"></i></td>
				<td><b>Rule Name: </b></td>
				<td>
					{{assetObj.info?.rule_name || 'N/A'}}
				</td>
			</tr>

			<ng-container *ngIf="assetObj.file_name">
				<tr>
					<td><i class="far fa-file text-muted"></i></td>
					<td><b>File Name: </b></td>
					<td>
						<span>{{assetObj.file_name}}</span>
						<span *ngIf="assetObj.size" style="font-size: 11px; color: #64748b;"> ({{assetObj.size | FormatBytes}})</span>
					</td>
				</tr>
				<tr *ngIf="assetObj.info?.file_path && assetObj.info?.webUrl">
					<td><i class="far fa-folder-open text-muted"></i></td>
					<td><b>File Path: </b></td>
					<td class="flex-row gap-2">
						{{assetObj.info?.file_path}}
					</td>
				</tr>
				<tr *ngIf="assetObj.info?.mime_type">
					<td><i class="far fa-code text-muted"></i></td>
					<td><b>MIME Type: </b></td>
					<td>
						<span>{{assetObj.info.mime_type}}</span>
					</td>
				</tr>
				<tr *ngIf="assetObj.permissions?.link?.scope">
					<td><i class="far fa-user-check text-muted"></i></td>
					<td><b>Permission:</b></td>
					<td class="flex-row gap-1">
						<div class="flex-row gap-1 align-items-center text-danger cursor-default" style="width: fit-content;"
							 *ngIf="assetObj.permissions?.link?.scope === 'anonymous'">
							<i class="far fa-exclamation-triangle"></i>
							<span class="fw-500">Anonymous</span>
						</div>
						<span *ngIf="assetObj.permissions?.link?.scope !== 'anonymous'">
							{{assetObj.permissions?.link?.scope}}
						</span>
						<i style="font-weight: 400;" class="far fa-question-circle" [tooltip]="linkScopeTooltips[assetObj.permissions?.link?.scope]" placement="right"></i>
					</td>
				</tr>
				<tr *ngIf="assetObj.permissions?.link?.webUrl">
					<td><i class="far fa-share-square text-muted"></i></td>
					<td><b>Shared link: </b></td>
					<td>
						<a class="blue-link text-decoration-underline" [href]="assetObj.permissions.link.webUrl" target="_blank">
							{{assetObj.permissions.link.webUrl}}
						</a>
					</td>
				</tr>
			</ng-container>
			<tr *ngIf="assetObj.asset_type === 'file' && assetObj.folder_id">
				<td><i class="far fa-bolt text-muted"></i></td>
				<td><b>Actions: </b></td>
				<td>
					<div class="flex-row gap-2">
						<btn-c style="width: 120px;"
							   [loading]="actionInProcess"
							   [isDisabled]="actionInProcess || assetObj.content?.content"
							   (action)="viewFile();">
							View file
						</btn-c>

						<btn-c style="width: 120px;"
							   *ngIf="assetObj.is_quarantine"
							   (action)="releaseAssetAction();">
							Release
						</btn-c>

						<btn-c style="width: 120px;"
							   *ngIf="!assetObj.is_quarantine"
							   (action)="quarantineAssetAction();">
							Quarantine
						</btn-c>
					</div>
				</td>
			</tr>

			<tr *ngIf="assetObj.asset_type === 'message'">
				<td><i class="far fa-bolt text-muted"></i></td>
				<td><b>Actions: </b></td>
				<td>
					<div class="flex-row gap-2">
						<btn-c style="width: 120px;"
							   [loading]="actionInProcess"
							   [isDisabled]="actionInProcess || assetObj.content?.content"
							   (action)="viewMessage();">
							View message
						</btn-c>
					</div>
				</td>
			</tr>
			<tr *ngIf="assetObj.content?.content">
				<td><i class="far fa-envelope-open text-muted"></i></td>
				<td><b>Content: </b></td>
				<td>
					<div class="p-2 border rounded-1" style="background: #f9f9f9; max-height: 300px; overflow-y: auto; font-size: 13px;"
						 [innerHTML]="assetObj.content.content">
					</div>
				</td>
			</tr>
		</table>

		<!--Content Analysis Data Card-->
		<div *ngIf="assetObj.sensitivity_info || assetObj.category === 'Malicious'"
			 class="threat-protection-card flxClmn ro10 co10 f-1-0 flex-shrink-0" [style.min-height]="assetObj.sensitivity_info ? '420px' : '300px'">
			<div class="card-header flxRow-between" style="align-items: center;">
				<span class="card-title">
					Content Analysis
				</span>

			</div>

			<!--malicious links-->
			<div class="animated fadeIn gap-3 flxClmn" style="padding: 15px; background: #f9f9f9; flex: 1 0;" *ngIf="assetObj.category === 'Malicious'">
				<span class="flxRow" style="align-items: center; font-size: 1.15rem; color: orangered;">
					<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
					Malicious link detected
				</span>

				<table class="w100 simpleDataTable">
					<tr *ngIf="assetObj.malicious_info.url">
						<th style="padding: 0; border: none; width: 150px;"></th>
						<th style="padding: 0; border: none;"></th>
					</tr>
					<tr *ngIf="assetObj.malicious_info.url">
						<td><b>URL address: </b></td>
						<td>
							<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{assetObj.malicious_info.url}}</span>
						</td>
					</tr>
					<tr *ngIf="assetObj.malicious_info.domain">
						<td><b>Domain: </b></td>
						<td>
							<span>{{assetObj.malicious_info.domain}}</span>
							<span *ngIf="assetObj.malicious_info.is_black_list"> (Blocklist)</span>
						</td>
					</tr>
					<tr *ngIf="assetObj.malicious_info.category">
						<td><b>Category: </b></td>
						<td>
							<span>{{assetObj.malicious_info.category}}</span>
						</td>
					</tr>
					<tr *ngIf="assetObj.malicious_info.status">
						<td><b>Type: </b></td>
						<td>
							<span [ngStyle]="{'color': assetObj.malicious_info.status === 'Safe' ? 'green' : assetObj.malicious_info.status === 'Malicious' ? 'darkred' : 'inherit'}">
							  {{assetObj.malicious_info.status}}
							</span>
						</td>
					</tr>
					<tr *ngIf="assetObj.malicious_info.sub_status && assetObj.malicious_info.sub_status.length">
						<td><b>Detection{{assetObj.malicious_info.sub_status.length > 1 ? 's' : ''}}: </b></td>
						<td>
							<div class="flxClmn vSpace1">
								<div *ngFor="let detection of assetObj.malicious_info.sub_status" class="flxRow hSpace1" style="color: darkred;">
									<i class="far fa-exclamation-triangle"></i>
									<span>{{detection.message}}</span>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="assetObj.malicious_info.malware_type">
						<td><b>Malicious link: </b></td>
						<td>
							<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{assetObj.malicious_info.malware_type}}</span>
						</td>
					</tr>
				</table>
			</div>

			<!--sensitive content-->
			<div class="animated fadeIn gap-3 flxClmn" style="padding: 15px; background: #f9f9f9; flex: 1 0;" *ngIf="assetObj.sensitivity_info">
				<span class="flxRow" style="align-items: center; font-size: 1.15rem; color: orangered;">
					<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
					Sensitive content detected
				</span>

				<div *ngIf="assetObj.sensitivity_info.sensitive_types?.length" class="flex-column f-1-0 gap-2" style="min-height: 300px;">
					<trustifi-table-c
						class="trustifi-table" style="flex: 1 0; z-index: 5;"
						[list]="assetObj.sensitivity_info.sensitive_types"
						[headers]="[
							{text: 'Type', sortKey: 'sensitive_type'},
							{text: 'Score', sortKey: 'score', width: '70px'},
							{text: 'Content'},
							{text: 'Compliance'},
						]"
						[cellsPrototype]="[
							{textKey: 'sensitive_type'},
							{textKey: 'score'},
							{html: 'contentCell'},
							{html: 'complianceCell'},
						]"
						[options]="{
							isEllipsis: false,
							itemsNameSingular: 'type',
						}"
					>
						<ng-template #customCells let-item let-cellId="cellId">
							<div *ngIf="cellId === 'contentCell'">
								<div class="px-2 py-1 border rounded-1 flex-row gap-2">
									<input class="f-1-0 border-0 p-0 h-auto" style="font-size: 12px; background: inherit;"
										   type="{{!item.showSensitiveContent ? 'password':'text'}}"
										   [ngStyle]="{'letter-spacing' : item.showSensitiveContent ? 'normal' : '2.4px'}"
										   [ngClass]="{'nofill': !item.showSensitiveContent}"
										   [ngModel]="item.content" disabled>

									<label class="hidepwd hvr-opacity" style="margin-bottom: 0; cursor: pointer; color: #676767;"
										   tooltip="{{item.showSensitiveContent ? 'Hide sensitive content' : 'Show sensitive content'}}">
										<input type="checkbox" [(ngModel)]="item.showSensitiveContent"/>
										<i class="fas fa-eye unchecked" ></i>
										<i class="fas fa-eye-slash checked"></i>
									</label>
									<i tooltip="Copy" class="far fa-copy copy-link" style="cursor: pointer; color: #676767;" (click)="gs.copyToClipboard(item.content);"></i>
								</div>
							</div>

							<div *ngIf="cellId === 'complianceCell'">
								<div class="value flex-row gap-2 justify-content-start flex-wrap">
									<span class="p-1 rounded-1 bg-dark bg-opacity-10"
										  *ngFor="let compliance of item.compliance" >
										{{compliance}}
									</span>
								</div>
							</div>
						</ng-template>

						<div tableButtons>
							<div class="flex-row p-1 rounded-1 align-items-center gap-1" style="border: 1px solid; width: 150px;"
								 [ngStyle]="assetObj.sensitivity_info.score === 0 && {'background-color':'#32cd324d', 'border-color':'limegreen'} || assetObj.sensitivity_info.score < 4 && {'background-color':'#ff8c004d', 'border-color':'darkorange'} || assetObj.sensitivity_info.score < 5 && {'background-color':'#FF851B4d', 'border-color':'#FF851B'} || assetObj.sensitivity_info.score === 5 && {'background-color':'#FF41364d', 'border-color':'#FF4136' }">
								<div class="header">Sensitivity Score:</div>
								<input type="button" value="{{assetObj.sensitivity_info.score}}"
									   [ngStyle]="assetObj.sensitivity_info.score === 0 && {'background':'limegreen'} || assetObj.sensitivity_info.score < 4 && {'background':'darkorange'} || assetObj.sensitivity_info.score < 5 && {'background':'#FF851B'} || assetObj.sensitivity_info.score === 5 && {'background':'#FF4136'}"
									   class="redborder" style="cursor: unset; width: 25px; margin: 0; padding-top: 4px; padding-bottom: 4px; border: 0; color: white !important;"
									   tooltip="Reflects how sensitive the content found in the email is on a scale of 0 (not sensitive) to 5 (extremely sensitive)" placement="right">
							</div>
						</div>
					</trustifi-table-c>
				</div>
			</div>
		</div>

		<!--Resource Information Data Card-->
		<div class="threat-protection-card flxClmn ro10 co10 flex-shrink-0" *ngIf="assetObj.resource_id">
			<div class="card-header flxRow-between" style="align-items: center;">
				<span class="card-title">
					Resource Information
				</span>
			</div>

			<div class="animated fadeIn flxClmn-center" style="padding: 15px; background: #f9f9f9;">
				<table class="w100 simpleDataTable" style="table-layout: fixed;">
					<tr>
						<td style="width: 120px;"><b>Type: </b></td>
						<td>
							<div class="flex-row align-items-center gap-2">
								<span>{{assetObj.resource_id.resource_type}}</span>
								<span style="display: inline-flex;align-items: center;gap: 5px;padding: 2px 8px !important;border-radius: 20px;font-size: 11px;font-weight: 600;background: #f1f5f9;color: #475569;"
									  *ngIf="assetObj.resource_id?.resource_sub_type === 'personal'">
									<i class="far fa-user" style="font-size: 10px; color: #486db5;"></i>
									Personal
								</span>
							</div>
						</td>
					</tr>
					<tr *ngIf="assetObj.resource_id.name">
						<td><b>Name: </b></td>
						<td>
							<span>{{assetObj.resource_id.name}}</span>
						</td>
					</tr>
					<tr *ngIf="assetObj.resource_id.members?.length">
						<td style="vertical-align: top;"><b>Members ({{assetObj.resource_id.members.length}}): </b></td>
						<td>
							<div class="flex-row gap-1 flex-wrap justify-content-start">
								{{assetObj.resource_id.members.join(', ')}}
							</div>
						</td>
					</tr>
					<tr *ngIf="assetObj.resource_id.external_members?.length">
						<td style="vertical-align: top;"><b>External ({{assetObj.resource_id.external_members.length}}): </b></td>
						<td>
							<div class="flex-row gap-1 flex-wrap justify-content-start">
								{{assetObj.resource_id.external_members.join(', ')}}
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</popup-c>

<attachment-preview
	*ngIf="previewAttachment"
	[attachment]="previewAttachment"
	(onClose)="previewAttachment = null;">
</attachment-preview>
